import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudLoaderModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { CreateMemedModalModule } from '../create-memed-dialog/create-memed-dialog.module';
import { MemedIntegration } from './memed-integration.component';

@NgModule({
	declarations: [MemedIntegration],
	imports: [
		CommonModule,
		CreateMemedModalModule,
		FreudLoaderModule,
		TranslateModule.forChild(),
	],
	exports: [MemedIntegration],
	providers: [],
})
export class MemedIntegrationModule {}
